import { Modelo } from '@ext/index';
import * as Types from './Cliente.types';
import moment, { Moment } from 'moment';
import { Cliente } from '@/__env/lib/Clientes/Cliente.nav';
import { Articulo } from '@/__env/lib/Articulos';
import { isObject } from 'util';
import * as Pedidos from '@lib/Ventas/Pedidos';
import { Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class ICliente extends Modelo
{

    public constructor ( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public get Persona (): Types.Personas
    {
        if ( this.Cuit && this.Cuit.startsWith( '3' ) )
            return Types.Personas.Juridica;
        return Types.Personas.Fisica;
    }

    public get esMinorista () { return this.Tipo == 'minorista'; }
    public get esMayorista () { return this.Tipo != 'minorista'; }
    public get esClienteMadrePlataformas ()
    {
        if ( this.Id )
        {
            for ( let p of Pedidos.Tipos.Plataformas )
            {
                if ( this.Id == p.ClientePredeterminado )
                    return true;
            }
        }

        return false;
    }

    public Tipo: string = 'minorista';

    public Cuenta: number = 0;
    public UsuarioMercadolibre: number = null;
    public NickNameMercadolibre: string = '';

    public RazonSocial: string = '';
    public Nombre: string = '';
    public Apellido: string = '';
    public TipoDocumento: string = 'DNI';
    public Documento: string = '';
    public Cuit: string = '';

    public PermiteOfertas: boolean = false;
    public PermiteBonificaciones: boolean = false;
    public TransportePredeterminado: string = '001';

    public CondicionIva: Types.Condiciones = Types.Condiciones.ConsumidorFinal;

    public Direccion: Direccion = new Direccion();
    public Contacto: Contacto = new Contacto();

    public get Iniciales (): string
    {
        let ini = "";

        if ( this.Apellido && this.Nombre )
        {
            ini += this.Nombre.substring( 0, 1 );
            ini += this.Apellido.substring( 0, 1 );
        } else if ( this.Nombre )
        {
            ini = this.Nombre.substring( 0, 2 );
        }
        else if ( this.RazonSocial )
        {
            ini = this.RazonSocial.substring( 0, 2 );
        }
        return ini.toUpperCase();
    }

    public getJson (): any
    {
        let json: any = {};

        json.persona = this.Persona.Id;
        json.tipo = this.Tipo;
        json.cuenta = this.Cuenta;
        json.usuario_mercadolibre = this.UsuarioMercadolibre;
        json.razon_social = this.RazonSocial;
        json.nombre = this.Nombre;
        json.apellido = this.Apellido;
        json.tipo_documento = this.TipoDocumento;
        json.documento = this.Documento;
        json.cuit = this.Cuit;
        json.condicion_iva = this.CondicionIva.Id;
        json.calle = this.Direccion.Calle;
        json.numero = this.Direccion.Numero;
        json.departamento = this.Direccion.Departamento;
        json.piso = this.Direccion.Piso;
        json.localidad = this.Direccion.Localidad;
        json.codigo_postal = this.Direccion.CodigoPostal;
        json.provincia = this.Direccion.Provincia;
        json.pais = this.Direccion.Pais;
        json.telefono = this.Contacto.Telefono;
        json.celular = this.Contacto.Celular;
        json.email = this.Contacto.Email;

        return json;
    }



    public set (): boolean
    {


        this.Id = !this.Json.id ? 0 : this.Json.id;


        this.CondicionIva = !this.Json.condicion_iva ? Types.Condiciones.ConsumidorFinal : Types.Condiciones.toTipo( this.Json.condicion_iva );

        this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
        this.Cuenta = !this.Json.cuenta ? 0 : this.Json.cuenta;
        this.UsuarioMercadolibre = !this.Json.usuario_mercadolibre ? null : this.Json.usuario_mercadolibre;
        this.NickNameMercadolibre = !this.Json.nickname_mercadolibre ? '' : this.Json.nickname_mercadolibre;
        this.RazonSocial = !this.Json.razon_social ? '' : this.Json.razon_social;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.Apellido = !this.Json.apellido ? '' : this.Json.apellido;
        this.TipoDocumento = !this.Json.tipo_documento ? '' : this.Json.tipo_documento;
        this.Documento = !this.Json.documento ? '' : this.Json.documento;
        this.Cuit = !this.Json.cuit ? '' : this.Json.cuit;

        this.Direccion.Calle = !this.Json.calle ? '' : this.Json.calle;
        this.Direccion.Numero = !this.Json.numero ? '' : this.Json.numero;
        this.Direccion.Departamento = !this.Json.departamento ? '' : this.Json.departamento;
        this.Direccion.Piso = !this.Json.piso ? '' : this.Json.piso;
        this.Direccion.Localidad = !this.Json.localidad ? '' : this.Json.localidad;
        this.Direccion.CodigoPostal = !this.Json.codigo_postal ? '' : this.Json.codigo_postal;
        this.Direccion.Provincia = !this.Json.provincia ? '' : this.Json.provincia;
        this.Direccion.Pais = !this.Json.pais ? '' : this.Json.pais;
        this.Contacto.Telefono = !this.Json.telefono ? '' : this.Json.telefono;
        this.Contacto.Celular = !this.Json.celular ? '' : this.Json.celular;
        this.Contacto.Email = !this.Json.email ? '' : this.Json.email;
        this.TransportePredeterminado = this.Json.logistica_predeterminada ? this.Json.logistica_predeterminada : '';
        this.PermiteOfertas = this.Json.ofertas_desactivadas != 'S';
        this.PermiteBonificaciones = this.Json.bonificaciones_desactivadas != 'S';

        this.Existe = true;
        return this.Existe;
    }

    public get Vista (): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor ( Model: ICliente )
    {
        this.Model = Model;
    }

    public Model: ICliente;
    public get Descripcion (): string
    {
        return this.Model.RazonSocial ? this.Model.RazonSocial : this.NombreCompleto;
    }

    public get NombreCompleto (): string
    {
        if ( this.Model.Nombre != this.Model.Apellido )
            return ( this.Model.Nombre ? this.Model.Nombre : '' ) + ( this.Model.Apellido ? ' ' + this.Model.Apellido : '' );
        else
            return ( this.Model.Nombre ? this.Model.Nombre : '' );

    }
}



class Direccion
{

    public Calle: string = '';
    public Numero: string = '';
    public Departamento: string = '';
    public Piso: string = '';
    public Localidad: string = '';
    public CodigoPostal: string = '';
    public Provincia: string = '';
    public Pais: string = 'ARGENTINA';

    public get Linea (): string
    {
        return ( this.Calle + ' ' + this.Numero + ' ' + this.Piso + this.Departamento + ' ' + this.Localidad + ' ' + this.CodigoPostal + ' ' + this.Provincia ).trim();
    }

    public get Valida (): boolean
    {
        let e = !this.Calle || !this.Localidad || !this.Provincia;
        return !e;
    }
}

class Contacto
{

    public Telefono: string = '';
    public Celular: string = '';
    public Email: string = '';
}

export class IEstadisticaVentas extends Modelo
{
    public constructor ( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Cliente: Cliente = new Cliente();
    public Mes: number = 0;
    public Ano: number = 0;
    public Porcentaje: number = 0;
    public Fecha: Moment;
    public Ventas: number = 0;
    public VentasFinales: number = 0;
    public NCMTotal: number = 0;
    public NCMImporte: number = 0;
    public NCMMotivos: {
        dev_motivo_codigo: string,
        importe: number,
        gastos: number,
        total: number,
        motivo: string;

    }[] = [];

    public esMercadoLibre = false;
    public Publicaciones: {
        estado: 'paused' | 'active',
        total: number,
    }[] = [];
    public get PublicacionesActivas () { return this.Publicaciones.find( item => item.estado === 'active' )?.total || 0; }
    public get PublicacionesPausadas () { return this.Publicaciones.find( item => item.estado === 'paused' )?.total || 0; }
    public get PublicacionesTotal () { return this.PublicacionesActivas + this.PublicacionesPausadas; }

    public set (): boolean
    {
        this.Mes = this.Json.mes;
        this.Ano = this.Json.ano;
        this.Fecha = moment( `${ this.Ano }-${ this.Mes }-1` );
        this.Ventas = this.Json.ventas;
        this.VentasFinales = this.Json.ventas_finales;
        this.NCMTotal = this.Json.total_nc?.total ||0;
        this.NCMImporte = this.Json.total_nc?.importe || 0;
        this.NCMMotivos = this.Json.motivos;
        this.Publicaciones = this.Json.publicaciones || [];
        this.Porcentaje = this.Json.porcentaje;
        if ( isObject( this.Json.cliente ) )
        {
            this.Cliente = new Cliente( this.Json.cliente );
        }

        this.Existe = true;
        return this.Existe;
    }
}

export class IEstadisticaArticulos extends Modelo
{
    public constructor ( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Articulo: Articulo = new Articulo();
    public Cliente: number = 0;
    public Mes: number = 0;
    public Ano: number = 0;
    public Cantidad: number = 0;
    public Fecha: Moment;
    public Ventas: number = 0;

    public set (): boolean
    {
        this.Mes = this.Json.mes;
        this.Ano = this.Json.ano;
        this.Fecha = moment( `${ this.Ano }-${ this.Mes }-1` );
        this.Ventas = this.Json.ventas;
        this.Cantidad = this.Json.cantidad;

        this.Articulo = new Articulo( this.Json.articulo );
        this.Existe = true;
        return this.Existe;
    }
}